import React, { useMemo } from 'react';
import { Pressable, ViewStyle } from 'react-native';
import { getStyles } from './ButtonIcon.styles';
import { useTheme } from '../../hooks/useTheme';
import Icon from '../Icon/Icon';
import { getContrastYIQ } from '@oolio-group/design-common';
import { ProgressDots } from '../ProgressDots/ProgressDots';

interface Props {
  id: string;
  icon: string;
  loading?: boolean;
  disabled?: boolean;
  buttonStyle?: 'primary' | 'secondary';
  onPress: () => void;
  containerStyles?: ViewStyle | ViewStyle[];
}

export const ButtonIcon: React.FC<Props> = ({
  id,
  icon,
  loading = false,
  disabled = false,
  buttonStyle = 'secondary',
  onPress,
  containerStyles,
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);

  const isDisabled = disabled || loading;
  const isPrimary = buttonStyle === 'primary';

  const fgColor = getContrastYIQ(colors.primary);
  const iconColor = isPrimary ? fgColor : colors.icon;

  return (
    <Pressable
      testID={id}
      onPress={onPress}
      disabled={isDisabled}
      style={({ pressed }) => [
        styles.container,
        isPrimary && styles.primary,
        containerStyles,
        pressed && styles.pressed,
        isDisabled && styles.disabled,
      ]}
    >
      {loading ? (
        <ProgressDots size={24} color={iconColor} />
      ) : (
        <Icon size={24} name={icon} color={iconColor} />
      )}
    </Pressable>
  );
};
